import { listCollection } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import styles from "./press.module.css";

const PAGE = {
  title: "Press",
  description: "Press releases and news coverage of RDV Systems.",
  path: "/resources/press",
};

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  return { items: listCollection("press") };
}

export default function Press({ loaderData }) {
  return (
    <>
      <PageHero
        eyebrow="Press"
        title="News and releases"
        lead={PAGE.description}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Resources", path: "/resources" },
          { name: "Press", path: PAGE.path },
        ]}
      />
      <section className="section">
        <div className={`container ${styles.list}`}>
          {loaderData.items.map((p) => (
            <article key={p.slug}>
              <p className="eyebrow">{[p.outlet, p.date].filter(Boolean).join(" · ")}</p>
              <h2>
                {p.url ? (
                  <a href={p.url} rel="noopener noreferrer" target="_blank">
                    {p.title}
                  </a>
                ) : (
                  p.title
                )}
              </h2>
              <p>{p.description}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
